// extracted by mini-css-extract-plugin
export default {"list":"ReviewClinicsList_list__g-0RN"};